import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToolSetService, PartService } from '../../../../../phf.service';
import { CgpConfirmationDialogService } from '../../../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { FilterableService } from '../../../../../../mesc/filterable-service';
import { PartListService } from '../../../part-list.service';

@Component({
      selector: 'toolset-edit-window',
      templateUrl: './toolset-edit-window.component.html',
      styleUrls: ['../../part-detail.component.scss', './toolset-edit-window.component.scss']
})
export class ToolsetEditWindowComponent implements OnInit {
      editForm: FormGroup;
      partForm: FormGroup;
      part: any;
      isServiceLoading = false;
      isWindowLoading = false;
      isToolSetCodeLoading = false;
      toolsetService: FilterableService = new FilterableService();
      pressService: FilterableService;
      plantService: FilterableService;
      partService: FilterableService = new FilterableService();

      // take in an edit form
      @Input()
      set data(editForm: any) {
            editForm.valueChanges.subscribe(value => {
                  this.part = editForm.value;
            })
            editForm.get('ToolSetId').valueChanges.subscribe(value => 
                  { 
                        this.editForm.get('ToolSetId').setValue(editForm.get('ToolSetId').value);
                        this.editForm.get('Code').setValue(editForm.get('ToolSetCode').value);
                        this.editForm.get('Parts').setValue(editForm.get('Parts').value);
                        this.editForm.get('Parentpart').setValue(editForm.get('Parentpart').value);
                  });
      }

      @Input()
      show: boolean;

      @Output()
      close: EventEmitter<any> = new EventEmitter<any>();
      @Output()
      save: EventEmitter<any> = new EventEmitter<any>();

      constructor(
            private readonly formBuilder: FormBuilder,
            public readonly phfToolsetService: ToolSetService,
            public readonly phfPartService: PartService,
            private readonly partListService: PartListService,
            private readonly cgpConfirmationDialog: CgpConfirmationDialogService,
      ) {
            this.isServiceLoading = true;
            this.pressService = this.partListService.lookupData.PressViewDto;
            this.plantService = this.partListService.lookupData.PlantViewDto;
            this.isServiceLoading = false;
       }

      private refreshPartList() {
            this.isServiceLoading = true;
            this.phfPartService.read()
                  .then(result => {
                        if (result) {
                              result.map(x => {
                                    const press = this.pressService.value.find(y => y.Id === x.PressId);
                                    const plant = this.plantService.value.find(x => x.Id === press.PlantId);
                                    if (press) {
                                          x.Code = `${x.Code}, ${plant.Name}, ${press.Number}`;
                                    }
                        });
                        result.sort((a, b) => a.Code.localeCompare(b.Code));
                        this.partService.next(result);
                        this.partService.minimumFilterLength = 0;
                  }
                  this.isServiceLoading = false;
            });

      }

      ngOnInit() {
            this.editForm = this.formBuilder.group(editForm);
            this.partForm = this.formBuilder.group(partForm);
      }

      refreshInfo() {
            this.refreshPartList();
            this.isWindowLoading = true;
            this.phfToolsetService.read()
                  .then(result => {
                        this.toolsetService.next(result);
                        if (this.editForm.get('ToolSetId').value) {
                              const toolSet = this.toolsetService.value.find(x => x.ToolSetId === this.editForm.get('ToolSetId').value)
                              this.handleToolSetCodeChange(toolSet.Code);
                        }
                        else if(!this.editForm.get('ToolSetId').value){
                              this.editForm.reset();
                        }
                        if (!this.editForm.get('Parts').value) {
                              this.editForm.get('Parts').setValue([]);
                        }
                  })
            this.isWindowLoading = false;
      }

      handleToolSetCodeChange = (dataItem) => {
            this.isToolSetCodeLoading = true;
            const toolSet = this.toolsetService.value.find(x => x.Code === dataItem);
            if (toolSet) {
                  toolSet.Parts.map(x => {
                        const part = this.partService.value.find(y => y.Code.includes(x.Code))
                        if (part) { x.Code = part.Code }
                  });
                  this.editForm.reset(toolSet);
            } else if (!dataItem) {
                  this.editForm.reset();
                  this.editForm.get('Parts').setValue([]);
            } else if (dataItem && !toolSet) {
                  if (this.part.Id) {
                        this.editForm.get('Parts').setValue([]);
                        const newPart = this.partForm.value;
                        newPart.Id = this.part.Id;
                        newPart.Code = this.part.Code;
                        this.editForm.get('Parts').value.push(newPart);
                        this.editForm.get('Parentpart').setValue(newPart);
                  }
            }
            this.isToolSetCodeLoading = false;
      }

      closeWindow() {
            this.close.emit();
      }

      onSave() {
            this.editForm.get('ToolSetId').value ?
                  this.phfToolsetService.save(this.editForm.value, false, "/" + this.editForm.get('ToolSetId').value).then(() => { this.save.emit(this.editForm); }) :
                  this.phfToolsetService.save(this.editForm.value, true).then(() => { this.save.emit(this.editForm); })
      }

      deleteToolset() {
            this.cgpConfirmationDialog.showConfirmationDialog({
                  title: 'Delete Confirmation',
                  message: `You are about to delete ${this.editForm.get('Code').value} from the system, do you wish to continue?`,
                  alert: 'danger',
                  onYesClick: () => {
                        this.phfToolsetService.remove('/' + this.editForm.get('ToolSetId').value)
                              .then(() => {
                                    this.handleToolSetCodeChange('');
                                    this.cgpConfirmationDialog.closeConfirmationDialog();
                                    this.save.emit(this.editForm);
                              })
                  },
                  onNoClick: () => {
                        this.cgpConfirmationDialog.closeConfirmationDialog();
                  }
            });
      }

      isDeleteDisabled(): boolean {
            if (this.editForm.get('Parts').value && this.editForm.get('Parts').value.length || !this.editForm.get('ToolSetId').value || this.isLoading()) {
                  return true;
            }
            return false;
      }

      checkParentCode(): boolean {
            const parentPart = this.editForm.get('Parts').value.find(x => x.Id === this.editForm.get('Parentpart').value.Id);
            if (!parentPart) { return true; }
            return false;
      }

      isSaveDisabled(): boolean {
            const ctrl = this.editForm.get('Parts');
            return ctrl.value && !ctrl.value.length ||
                  !this.editForm.get('Parentpart').value ||
                  this.isLoading() || this.checkParentCode();
      }

      isLoading(): boolean{
            if(this.isServiceLoading || this.isWindowLoading || this.isToolSetCodeLoading){
                  return true;
            }
            return false;
      }
}

const editForm = {
      ToolSetId: [],
      Code: [],
      Parts: [[], Validators.required],
      Parentpart: ['', Validators.required],
}

const partForm = {
      Id: [],
      Code: [],
}
